import { render } from "./emptyComp.vue?vue&type=template&id=39f1886d"
import script from "./emptyComp.vue?vue&type=script&lang=js"
export * from "./emptyComp.vue?vue&type=script&lang=js"

import "./emptyComp.vue?vue&type=style&index=0&id=39f1886d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__